import {
  FetchTargetRate,
  FetchTargetRateVariables,
} from "_graphql/queries/__generated__/FetchTargetRate";
import {
  FetchTargetRates,
  FetchTargetRatesVariables,
} from "_graphql/queries/__generated__/FetchTargetRates";
import {
  fetchTargetRate,
  fetchTargetRates,
} from "_graphql/visal/queries/target-rate";

import { useQuery } from "@apollo/client";

export const useTargetRates = (targetId: string) => {
  const { data, loading, error, refetch } = useQuery<
    FetchTargetRates,
    FetchTargetRatesVariables
  >(fetchTargetRates, {
    variables: {
      targetId,
    },
    fetchPolicy: "network-only",
  });

  return {
    targetRates: data?.fetchTargetRates || [],
    loading,
    error,
    refetch,
  };
};


export const useTargetRate = (rateId: string) => {
  const { data, loading, error, refetch } = useQuery<
    FetchTargetRate,
    FetchTargetRateVariables
  >(fetchTargetRate, {
    variables: {
      targetRateId: rateId,
    },
    fetchPolicy: "network-only",
    skip: !rateId,
  });

  return {
    targetRate: data?.fetchTargetRate || null,
    loading,
    error,
    refetch,
  };
};
